import React from 'react';
import { Modal } from '@superops/ui-design-system';
import { InvoiceTransactionListTable } from '@nile/client_management/src/Pages/Invoice/InvoiceTransactionListTable';
import { getTranslatedText, Loader, COMMON_CONSTANTS } from '@nile/components';
import { useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';
import { GET_PAYMENT_TRANSACTION_LIST } from '@nile/graphql/src/Query/client_management/partialPayments';
import { AccountClient } from '@nile/graphql';

export function InvoiceTransactionsListModal({ open, onClose, paymentId }) {
  const Intl = useIntl();
  const { data, loading } = useQuery(GET_PAYMENT_TRANSACTION_LIST, {
    client: AccountClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    variables: {
      input: {
        pageSize: 100,
        page: 1,
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'payment.paymentId',
              operator: 'is',
              value: paymentId
            }
          ]
        },
        sort: [
          {
            attribute: 'createdTime',
            order: 'DESC'
          }
        ]
      }
    }
  });

  return (
    <Modal
      title={getTranslatedText(Intl, 'invoice.partialPayments.invoiceList')}
      open={open}
      large
      noScroll
      showCloseButton
      onClose={onClose}
    >
      {loading ? (
        <div className="height100">
          <Loader />
        </div>
      ) : (
        <InvoiceTransactionListTable
          transactions={data?.getPaymentTransactionList?.transactions ?? []}
          hideDelete
        />
      )}
    </Modal>
  );
}
